import React from "react";

import {
  Phone,
  Mail,
  User,
  Trophy,
  Building2,
} from "lucide-react";

import { useLeadStore } from "../../store/leadStore";
import LeadCategory from "./LeadCategory";

import Card from "../ui/Card";
import InfoItem from "../ui/InfoItem";

import "../../styles/lead_basic_info.css";

const LeadBasicInfo = () => {
  const { selectedLead } =
    useLeadStore();

  return (
    <Card className="lead-basic-info-card max-w-0 m-0">
      {/* HEADER */}
      <div className="d-flex align-center justify-between">
      <div className="mb-4 d-flex flex-column gap-2">
        <h2 className="m-0 text-primary">
          {selectedLead?.name ||
            "Unknown Lead"}
        </h2>
        <p className="lead-subtitle text-muted mt-1 m-0">
          {selectedLead?.source ||
            "Unknown"}{" "}
          Lead
        </p>
      </div>
      <div className="d-flex align-start gap-2 mb-auto">
        <LeadCategory score={selectedLead?.score || 0} />
      </div>
      </div>

      {/* INFO GRID */}
      <div className="grid-auto-fit">
        <InfoItem
          icon={Phone}
          label="Phone"
        >
          <p className="m-0 fw-semibold text-primary">
            {selectedLead?.phone ||
              "N/A"}
          </p>
        </InfoItem>

        <InfoItem
          icon={Mail}
          label="Email"
        >
          <p className="m-0 fw-semibold text-primary">
            {selectedLead?.email ||
              "N/A"}
          </p>
        </InfoItem>

        <InfoItem
          icon={Building2}
          label="Source"
        >
          <p className="m-0 fw-semibold text-primary">
            {selectedLead?.source ||
              "N/A"}
          </p>
        </InfoItem>

        <InfoItem
          icon={Trophy}
          label="Lead Score"
        >
          <p className="m-0 fw-semibold text-primary">
            {Math.min(
              selectedLead?.score || 0,
              100
            )}
          </p>
        </InfoItem>

        <InfoItem
          icon={User}
          label="Assigned Agent"
        >
          <p className="m-0 fw-semibold text-primary">
            {selectedLead?.agent_name ||
              "Unassigned"}
          </p>
        </InfoItem>
      </div>
    </Card>
  );
};

export default LeadBasicInfo;